import { CustomerInterface } from "../../models/TicketModule/Customer";
import client from "../client";

class CustomerService {
  async GetAll(page: number, pageSize: number) {
    try {
      let url = `/api/customers/get`;
      const formData = {
        page,
        pageSize,
      };

      const { data } = await client.post<CustomerInterface[]>(url, formData);
      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
  async GetByCompId(
    page: number,
    pageSize: number,
    companyId: string | undefined
  ) {
    try {
      let url = `/api/customers/get`;
      const formData = {
        page,
        pageSize,
        companyId,
      };
      if (!companyId) return [];
      else {
        const { data } = await client.post<CustomerInterface[]>(url, formData);
        return data;
      }
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
  async GetByCompLocId(
    page: number,
    pageSize: number,
    companyId: string | undefined,
    locationId: string | undefined
  ) {
    try {
      let url = `/api/customers/get`;
      const formData = {
        page,
        pageSize,
        companyId,
        locationId,
      };
      if (!companyId || !locationId) return [];
      else {
        const { data } = await client.post<CustomerInterface[]>(url, formData);
        return data;
      }
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async GetById(id: string) {
    try {
      let url = `/api/customers/getbyid/${id}`;

      const { data } = await client.get<CustomerInterface>(url);

      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async Save(customer: CustomerInterface) {
    try {
      let url = `/api/customers/add`;

      const { data } = await client.post<CustomerInterface>(url, customer);

      return data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  async Update(id: string, customer: CustomerInterface) {
    try {
      let url = `/api/customers/update/${id}`;

      const { data } = await client.post<CustomerInterface>(url, customer);

      return data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
  async Remove(id: string) {
    try {
      let url = `api/customers/remove/${id}`;
      await client.post<CustomerInterface>(url, { url: "" });
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
}

export default new CustomerService();
